export default {
  label: {
    sk: 'Politika spoločnosti',
    en: 'Company policy',
  },
};



// WEBPACK FOOTER //
// ./src/modules/CompanyPolicy/messages.js